import React, { Fragment, useEffect, useState } from "react";
import { PageBanner } from "../../components";
import { Helmet } from "react-helmet";
import {
  Container,
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Paper,
  Button,
  Typography,
} from "@material-ui/core";
import { backend } from "../../api";
import { useHistory } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ExpandMore } from "@material-ui/icons";
import { useSelector } from "react-redux";
import BuyArticle from "./components/BuyArticle";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FreeArticle from "./components/FreeArticle";
import GotoCartModal from "./components/GotoCartModal";
import theme from "../../theme";
import CheckoutModal from "../../components/Modals/CheckoutModal";
import { useMyContext } from "../../contextApi/context";

const useStyle = makeStyles((theme) => ({
  accordion: {
    backgroundColor: theme.palette.primary.dark,
  },
  accordionSummary: {
    padding: "20px 20px",
    backgroundColor: theme.palette.primary.dark,
  },
  directoryName: {
    margin: 0,
    fontWeight: "700",
    color: theme.palette.black,
  },
  articleBtn: {
    color: theme.palette.secondary.light,
    border: `1px solid ${theme.palette.secondary.light}`,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  headWrapper: {
    backgroundColor: theme.palette.primary.dark,
    height: 50,
  },
  headerNew: {
    color: theme?.palette.white,
    fontSize: 22,
    fontWeight: "500",
  },
  filledHeart: {
    color: theme.palette.primary.main,
  },
  blackText: {
    color: theme.palette.black,
    padding: 0,
    margin: 0,
  },
  cardBtnsWrap: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  centerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  disabledButton: {
    backgroundColor: "white",
    color: "white",
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  skeleton: {
    backgroundColor: theme.palette.grey[700],
  },
  root: {
    width: "100%",
    backgroundColor: "black",
    minHeight: "58vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  gridItem: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
  },
}));

function Articles({ setCartCounter }) {
  const [directories, setDirectories] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState("");
  const [favourites, setFavourites] = useState();
  const [buyModal, setBuyModal] = useState(false);
  const [modalArticle, setModalArticle] = useState();
  const [amounts, setAmounts] = useState();
  const [loading, setLoading] = useState(true); // New state for loading
  const state = useSelector((state) => state.customer);
  const { currentUser } = useSelector((state) => state.auth);
  const [freeModal, setFreeModal] = useState(false);
  const [checkoutModal, setCheckoutModal] = useState(false);
  const history = useHistory();
  const { setCartItems, setBook, cartItems } = useMyContext();
  const [addingToCart, setAddingToCart] = useState(false);

  const classes = useStyle();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (currentUser?.user) {
      handleFetchFavourites();
      handleFetchCurrentAmount();
    }
    handleFetchDirectories();
  }, []);

  const handleFetchDirectories = () => {
    backend
      .get("/directory?isActive=true")
      .then((res) => {
        setDirectories(res?.data?.data);
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch((err) => {
        if (err.response) {
          setError(err.response.data.message);
        } else {
          setError(err.message);
        }
        setLoading(false); // Set loading to false in case of error
      });
  };

  const handleFetchFavourites = () => {
    backend
      .get(`/favourite?customer=${state?.user?.user?._id}`)
      .then((res) => {
        setFavourites(res?.data?.data[0]);
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
      });
  };

  const handleFetchCurrentAmount = () => {
    backend
      .get("/amount")
      .then((res) => {
        setAmounts(res?.data?.data[0]);
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
      });
  };

  const handleBuyModalOpen = (article) => {
    setModalArticle(article);
    setBuyModal(true);
  };

  const handleBuyModalClose = () => {
    setBuyModal(false);
  };

  const handleFreeModalOpen = (article) => {
    setModalArticle(article);
    setFreeModal(true);
  };

  const handleFreeModalClose = () => {
    setFreeModal(false);
  };

  const handleFreeModalCheckout = () => {
    setCheckoutModal(false);
  };

  const handleAddToFavourite = (article) => {
    const newFav = {
      article: article?._id,
      date_updated: new Date(),
    };
    backend
      .put(`/favourite/${favourites?._id}`, newFav)
      .then((res) => {
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };

  const goToCheckout = () => {
    history.push("/shopping-cart");
  };

  const handleAddToCart = (event, item, directory) => {
    event.preventDefault();
    const isAdding = directory.article.some((dir) => dir._id === item._id);
    if (isAdding) {
      setAddingToCart(true);
      const token = localStorage.getItem("Token");

      backend
        .post(
          `/shopCart`,
          { articleId: item._id, cartItemType: "ARTICLE" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          toast.success("Item Added to the cart successfully.");
          backend
            .get("/shopCart")
            .then((response) => {
              localStorage.setItem(
                "cartItem",
                JSON.stringify(response?.data?.data)
              );
              localStorage.setItem(
                "length",
                JSON.stringify(response?.data?.data.length)
              );
              setBook(response?.data);
              setCartItems(response?.data?.data);
            })
            .catch((error) => {
              toast.error(error.message);
            })
            .finally(() => {
              setAddingToCart(false);
            });
        })
        .catch((error) => {
          toast.error("Item did not get added.");
          console.error(error);
          setAddingToCart(false);
        }).finally(()=>{
          setAddingToCart(false)
        });
    }
  };

  const handleViewArticle = (directoryId, articleId) => {
    history.push(`/directory/${directoryId}/article/${articleId}/view`);
  };

  return (
    <Fragment>
      <Helmet>
        <title>Paper Jumpsuit Index</title>
      </Helmet>
      <PageBanner image={"/assets/images/bg4.jpg"} title={"Paper Jumpsuit Index"} />
      <ToastContainer />
      <Box className={classes.root} py={5}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8} lg={9}>
              <Box className={classes.centerContainer}>
                {loading ? ( // Conditionally render a single skeleton
                  <Box my={3} width="100%">
                    <Skeleton
                      variant="rect"
                      width="100%"
                      animation="wave"
                      className={classes.skeleton} 
                    />
                  </Box>
                ) : directories.length > 0 ? (
                  <Box my={3}>
                    {directories.map((directory, index) => (
                      <Accordion
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                        className={classes.accordion}
                        key={index}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <h3 className={classes.directoryName}>
                            {directory.directory_name}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid
                            className={classes.accordion}
                            container
                            spacing={2}
                          >
                            {directory.article
                              .filter((item) => item.isActive)
                              .map((item, index) => (
                                <Grid item xs={12} lg={6} key={index} className={classes.gridItem}>
                                  <Paper
                                    elevation={2}
                                    style={{
                                      height: "100%",
                                      padding: 10,
                                      backgroundColor: theme?.palette.black,
                                    }}
                                  >
                                    <div className={classes.cardBtnsWrap}>
                                      <div>
                                        <h3
                                          style={{
                                            margin: 0,
                                            color: theme?.palette.white,
                                          }}
                                        >
                                          {item.article_title}
                                        </h3>
                                        <p
                                          style={{
                                            margin: 0,
                                            color:
                                              theme?.palette.secondary.dark,
                                          }}
                                        >
                                          <b>Total Pages: </b>
                                          {item.number_of_pages}
                                        </p>
                                        <p
                                          style={{
                                            margin: 0,
                                            color:
                                              theme?.palette.secondary.dark,
                                          }}
                                        >
                                          <b>Per Page Price: </b>
                                          {item.per_page_price} $
                                        </p>
                                      </div>
                                      <Box
                                        className={classes.buttonContainer}
                                      >
                                        {currentUser?.author?.role !== "author" && ( 
                                          <Button
                                            className="ml-3"
                                            color="primary"
                                            variant="contained"
                                            onClick={(event) => {
                                              handleAddToCart(event, item, directory);
                                            }}
                                            disabled={cartItems.some(
                                              (product) =>
                                                product?.articleId &&
                                                product?.articleId._id ===
                                                  item._id
                                            ) || addingToCart}
                                            style={{
                                              backgroundColor: cartItems.some(
                                                (product) =>
                                                  product?.articleId &&
                                                  product?.articleId._id ===
                                                    item._id
                                              )
                                                ? "rgb(175 159 87)"
                                                : addingToCart
                                                ? "#FECE00"
                                                : undefined,
                                            }}
                                          >
                                            <p className={classes.blackText}>
                                              Add to Cart
                                            </p>
                                          </Button>
                                        )}
                                       <Button
                                          color="primary"
                                          variant="contained"
                                          onClick={() => handleViewArticle(directory._id, item._id)}
                                          disabled={addingToCart}
                                          style={{
                                            backgroundColor: addingToCart
                                              ? "#FECE00"
                                              : undefined,
                                          }}
                                        >
                                          <p className={classes.blackText}>
                                            View
                                          </p>
                                        </Button>
                                      </Box>
                                    </div>
                                  </Paper>
                                </Grid>
                              ))}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                ) : (
                  <Box textAlign="center">
                      <Typography variant="h5" style={{color : "red"}}>No directories found.</Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {amounts && modalArticle && (
        <BuyArticle
          visible={buyModal}
          closeModal={handleBuyModalClose}
          tax={amounts.tax}
          article={modalArticle}
          user={state.user}
        />
      )}

      <GotoCartModal
        visible={checkoutModal}
        goToCheckout={goToCheckout}
        closeModal={handleFreeModalCheckout}
      />

      {amounts && modalArticle && (
        <FreeArticle
          visible={freeModal}
          closeModal={handleFreeModalClose}
          tax={amounts.tax}
          article={modalArticle}
          user={state.user}
        />
      )}
    </Fragment>
  );
}

export default Articles;
